import { useState } from "react";
import { Link } from "react-router-dom";
import { HeaderNav } from "@/components/HeaderNav";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(data.message);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div>
      <HeaderNav />
      <div className="max-w-md mx-auto px-5 pt-24 pb-16 cg-fade-up">
        <h1 className="font-serif text-4xl text-[#F3F4F6] mb-2">Forgot your password?</h1>
        <p className="text-[#9CA3AF] mb-8">
          Enter the email address you used to create your Caesar's Ghost account. We'll send you a link to reset your password.
        </p>
        {sent ? (
          <div className="cg-card p-7" data-testid="forgot-password-sent">
            <p className="text-[#E8EAEE] leading-relaxed">{sent}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="cg-card p-7 space-y-5">
            <div>
              <label className="text-sm text-[#9CA3AF]">Email address</label>
              <input data-testid="forgot-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full bg-[#0D0E12] border border-[var(--cg-border)] rounded-lg px-4 py-3 text-[#F3F4F6] focus:border-brass focus:outline-none transition-colors" />
            </div>
            {error && <p data-testid="forgot-error" className="text-sm text-terracotta">{error}</p>}
            <button data-testid="forgot-submit-button" disabled={busy}
              className="w-full bg-brass text-obsidian font-medium py-3 rounded-full cg-scale-btn hover:bg-amber2 disabled:opacity-60">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <p className="mt-5 text-sm">
          <Link to="/login" data-testid="back-to-signin-link" className="cg-link">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
